import type { Feature } from './Feature';
import { PricingTier } from './PricingTier';

export class Subscription {
  constructor(
    public readonly pricingTier: PricingTier | null,
    public readonly features: Feature[],
  ) {}
}
